export default class ObservationCrm {
  id!: number
  member_number_id!: number
  date_observation!: Date
  reading_date!: Date
  observation!: string
}
